import React, { useEffect, useState, useImperativeHandle } from 'react';
import { apiHolder, apis, getIn18Text, } from 'api';
import { navigate } from '@reach/router';
import classnames from 'classnames';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { message, Modal, Skeleton, Drawer } from 'antd';
import { ReactComponent as ArrowIcon } from '@/images/icons/edm/yingxiao/arrow-right.svg';
import { getSendCount } from '@/components/Layout/Customer/components/hooks/useEdmSendCount';
import { usePermissionCheck } from '@/components/UI/PrivilegeEnhance';
import styles from './MailTemplateListV2.module.scss';
import { TaskCard } from './TaskCard';
import { PersonalCard } from './PersonalCard';
import { setTemplateContent } from '../template-util';
import Preview from '../template/preview';
import { TemplateAddModal } from '../template';
import { edmDataTracker } from '../../tracker/tracker';
const systemApi = apiHolder.api.getSystemApi();
const routerWord = systemApi.isWebWmEntry() ? '#intelliMarketing' : '#edm';
const edmApi = apiHolder.api.requireLogicalApi(apis.edmSendBoxApiImpl);
const templateApi = apiHolder.api.requireLogicalApi(apis.mailTemplateImplApi);
export var TemplateType;
(function (TemplateType) {
    TemplateType[TemplateType["recently"] = 1] = "recently";
    TemplateType[TemplateType["individual"] = 2] = "individual";
    TemplateType[TemplateType["recommendation"] = 3] = "recommendation";
    TemplateType[TemplateType["enterprise"] = 4] = "enterprise";
    TemplateType[TemplateType["task"] = 5] = "task";
})(TemplateType || (TemplateType = {}));
export const TypeLabel = {
    task: getIn18Text('zuijintask3'),
    recommendation: getIn18Text('tuijianmoban3'),
    recently: getIn18Text('zuijinshiyongmoban3'),
    individual: getIn18Text('gerenmoban3'),
    enterprise: getIn18Text('qiye_moban3'),
};
export const MailTemplateListV2 = React.forwardRef((props, ref) => {
    const { showMore, displayTemplate, isFormWrite, onUse } = props;
    const [taskList, setTaskList] = useState();
    const [recommendList, setRecommendList] = useState();
    const [recentlyList, setRecentlyList] = useState();
    const [individualList, setIndividualList] = useState();
    const [enterpriseList, setEnterpriseList] = useState();
    const [loading, setLoading] = useState(false);
    const [taskLoading, setTaskLoading] = useState(false);
    const [showDrawer, setShowDrawer] = useState(false);
    const [showDrawerPageType, setShowDrawerPageType] = useState('task');
    const [previewId, setPreviewId] = useState('');
    const [editContent, setEditContent] = useState('');
    const [allTemplateId, setAllTemplateId] = useState([]);
    const hasEdmPermission = usePermissionCheck('VIEW', 'EDM', 'EDM_SENDBOX');
    const addNewTemplate = (content, id = '') => {
        setPreviewId(id);
        setEditContent(content);
    };
    const goWritePage = () => {
        getSendCount({
            emailList: [],
            from: 'template',
            back: encodeURIComponent(`${routerWord}?page=mailTemplate&version=v2`),
        });
    };
    const minLength = isFormWrite ? 2 : 4;
    const queryTaskList = async () => {
        setTaskLoading(true);
        try {
            const taskList = await edmApi.getTaskBrief({
                size: isFormWrite ? 3 : 5,
            });
            setTaskList(taskList);
        }
        catch (err) { }
        setTaskLoading(false);
    };
    const getList = (templateList, type, setList) => {
        const list = templateList.find(list => list.tabId === TemplateType[type]);
        if (list) {
            setList(list.templateList);
            return list.templateList.map(info => info.templateId);
        }
        return [];
    };
    useImperativeHandle(ref, () => ({
        refresh(loading) {
            queryTemplateList(loading);
        },
    }));
    const renderTemplateView = () => (React.createElement(Drawer, { bodyStyle: { padding: '0px' }, width: 872, title: null, closable: false, onClose: () => {
            setShowDrawer(false);
            setShowDrawerPageType('task');
        }, visible: showDrawer, destroyOnClose: true },
        React.createElement(Preview, { templateId: previewId, allTemplateId: allTemplateId, closeModal: () => {
                setShowDrawer(false);
                setShowDrawerPageType('task');
            }, emitResult: () => { }, onUse: (content, templateId) => {
                setShowDrawer(false);
                setShowDrawerPageType('task');
                if (isFormWrite) {
                    onUse && onUse(templateId, content, showDrawerPageType);
                }
                else {
                    setTemplateContent(content, templateId);
                    navigate(`${routerWord}?page=write&from=template`);
                }
            } })));
    const queryTemplateList = async (showLoading) => {
        showLoading && setLoading(true);
        try {
            const templateList = await templateApi.getTemplateTop({
                size: isFormWrite ? 3 : 5,
                templateCategory: 'LX-WAIMAO',
            });
            getList(templateList, 'recommendation', setRecommendList);
            getList(templateList, 'individual', setIndividualList);
            getList(templateList, 'enterprise', setEnterpriseList);
            getList(templateList, 'recently', setRecentlyList);
        }
        catch (err) { }
        setLoading(false);
    };
    useEffect(() => {
        if (hasEdmPermission) {
            queryTaskList();
        }
    }, [hasEdmPermission]);
    useEffect(() => {
        queryTemplateList();
    }, []);
    const saveTaskAsTemplate = async (templateId, callback) => {
        try {
            const res = await templateApi.doGetMailTemplateDetail({ templateId });
            if (res.success && res.data) {
                callback(res.data.content);
            }
        }
        catch (err) {
            message.error(getIn18Text('HUOQURENWUXIANGQINGSHI'));
        }
    };
    const actionTrace = (type, source) => {
        if (!isFormWrite) {
            if (type === 'use') {
                edmDataTracker.templatePageOp('use', source);
            }
            else if (type === 'saveTemplate') {
                edmDataTracker.templatePageOp('save', source);
            }
            else if (type === 'display') {
                edmDataTracker.templatePageOp('viewTemplate', source);
            }
            else if (type === 'more') {
                edmDataTracker.templatePageOp('more', source);
            }
        }
        else {
            let type = '';
            switch (source) {
                case 'recommendation':
                    type = 'useRecomend';
                    break;
                case 'recently':
                    type = 'useRecently';
                    break;
                case 'individual':
                    type = 'usePersonal';
                    break;
                case 'enterprise':
                    type = 'useCompany';
                    break;
                case 'task':
                    type = 'useTask';
                    break;
                default:
                    type = '';
            }
            edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                type: type,
            });
        }
    };
    const getCard = (pageType, list) => {
        if (pageType === 'task') {
            return taskList === null || taskList === void 0 ? void 0 : taskList.tasks.map(task => React.createElement(TaskCard, { isFormWrite: isFormWrite, onUse: onUse, addNewTemplate: addNewTemplate, key: task.edmEmailId, task: task }));
        }
        else {
            const originList = list;
            return list === null || list === void 0 ? void 0 : list.map(list => (React.createElement(PersonalCard, { isFormWrite: isFormWrite, cardOp: (type, templateId) => {
                    actionTrace(type, pageType);
                    if (type === 'use') {
                        templateApi.doSaveMailTemplateUseTime({ templateId, time: new Date().getTime() });
                        templateApi.doGetMailTemplateDetail({ templateId }).then(async (res) => {
                            if (res.success && res.data) {
                                setTemplateContent(res.data.content, templateId);
                                if (isFormWrite) {
                                    onUse && onUse(templateId, res.data.content, pageType);
                                }
                                else {
                                    navigate(`${routerWord}?page=write&from=template`);
                                }
                            }
                        });
                    }
                    else if (type === 'display') {
                        setShowDrawer(true);
                        setShowDrawerPageType(pageType);
                        setPreviewId(templateId);
                        setAllTemplateId(originList.map(listItem => listItem.templateId));
                        edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                            type: 'viewTemplate',
                        });
                    }
                    else if (type === 'edit') {
                        saveTaskAsTemplate(templateId, content => {
                            addNewTemplate && addNewTemplate(content, templateId);
                        });
                    }
                    else if (type === 'saveTemplate') {
                        edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                            type: 'save',
                        });
                        saveTaskAsTemplate(templateId, content => {
                            addNewTemplate && addNewTemplate(content);
                        });
                    }
                    else if (type === 'delete') {
                        Modal.confirm({
                            title: getIn18Text('QUEDINGYAOSHANCHUGAIMOBANMA\uFF1F'),
                            okText: getIn18Text('QUEDING'),
                            cancelText: getIn18Text('QUXIAO'),
                            centered: true,
                            onOk: () => {
                                templateApi
                                    .doDeleteMailTemplate({
                                    templateId,
                                })
                                    .then(res => {
                                    if (res.data === 'success') {
                                        message.success(getIn18Text('SHANCHUCHENGGONG'));
                                        queryTemplateList();
                                    }
                                    else {
                                        message.error(getIn18Text('SHANCHUSHIBAI\uFF0CQINGZHONGSHI'));
                                    }
                                });
                            },
                        });
                    }
                }, templateInfo: list })));
        }
    };
    const renderSubList = (title, key, list, moreTitle = getIn18Text('gengduo3')) => (React.createElement("div", { className: styles.subList, key: key },
        React.createElement("div", { className: styles.subListHeader },
            React.createElement("div", { className: styles.leftHeader }, title),
            React.createElement("div", { className: styles.rightHeader, onClick: () => {
                    actionTrace('more', key);
                    showMore(title, key, TemplateType[key]);
                } }, ((list === null || list === void 0 ? void 0 : list.length) || 0) > minLength && (React.createElement(React.Fragment, null,
                moreTitle,
                React.createElement(ArrowIcon, { className: styles.headerIcon }))))),
        React.createElement("div", { className: styles.subListContent }, getCard(key, list))));
    if (taskLoading || loading) {
        return (React.createElement("div", { className: styles.wrap },
            React.createElement("div", { className: styles.list, key: "task" },
                React.createElement("div", { style: {
                        padding: 16,
                    } },
                    React.createElement(Skeleton, { active: true })))));
    }
    const renderAddModal = () => {
        if (isFormWrite) {
            return (React.createElement(SiriusModal, { className: styles.myModal2, visible: editContent !== '', onCancel: () => setEditContent(''), title: "", width: 900, footer: null },
                React.createElement(TemplateAddModal, { content: editContent, templateId: previewId, goMailTemplate: refresh => {
                        if (refresh) {
                            queryTemplateList();
                        }
                        setEditContent('');
                        setPreviewId('');
                    } })));
        }
        return (React.createElement("div", { className: styles.editWrap },
            React.createElement(TemplateAddModal, { content: editContent, templateId: previewId, goMailTemplate: refresh => {
                    if (refresh) {
                        queryTemplateList();
                    }
                    setEditContent('');
                    setPreviewId('');
                } })));
    };
    return (React.createElement(React.Fragment, null,
        editContent && renderAddModal(),
        React.createElement("div", { className: classnames(styles.wrap, isFormWrite ? styles.wrapWrite : '') },
            React.createElement("div", { className: styles.list, key: "task" },
                taskList != null && taskList.tasks.length > 0 && renderSubList(TypeLabel.task, 'task', taskList.tasks),
                recommendList != null && recommendList.length > 0 && renderSubList(TypeLabel.recommendation, 'recommendation', recommendList, getIn18Text('gengduo3')),
                recentlyList != null && recentlyList.length > 0 && renderSubList(TypeLabel.recently, 'recently', recentlyList, getIn18Text('gengduo3')),
                individualList != null && individualList.length > 0 && renderSubList(TypeLabel.individual, 'individual', individualList, getIn18Text('gengduo3')),
                enterpriseList != null && enterpriseList.length > 0 && renderSubList(TypeLabel.enterprise, 'enterprise', enterpriseList, getIn18Text('gengduo3'))),
            renderTemplateView())));
});
